import clsx from 'clsx';

interface AvatarProps {
  src?: string | null;
  name: string;
  online?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-16 w-16 text-xl',
};

export default function Avatar({ src, name, online, size = 'md', className }: AvatarProps) {
  const initials = name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');

  return (
    <div className={clsx('relative shrink-0', className)}>
      <div
        className={clsx(
          'grid place-items-center overflow-hidden rounded-lg border border-white/10 bg-gradient-to-br from-relay-blue/80 to-relay-violet/80 font-semibold text-white shadow-glow',
          sizeClasses[size],
        )}
      >
        {src ? (
          <img src={src} alt="" className="h-full w-full object-cover" referrerPolicy="no-referrer" />
        ) : (
          initials || '?'
        )}
      </div>
      {online !== undefined && (
        <span
          className={clsx(
            'absolute -bottom-0.5 -right-0.5 h-3.5 w-3.5 rounded-full border-2 border-ink-850',
            online ? 'bg-relay-green' : 'bg-slate-500',
          )}
          aria-label={online ? 'Online' : 'Offline'}
        />
      )}
    </div>
  );
}

